<script lang="ts">
  // UI components
  import * as Accordion from '$lib/components/ui/accordion/index.js';
  import { Label } from '$lib/components/ui/label/index.js';
  import * as RadioGroup from '$lib/components/ui/radio-group/index.js';

  // Roastlog
  import { referenceRoastEventDisplay } from '$lib/PersistedState.svelte';

  const displayOptions = [
    { value: 'dots', label: 'Draw event dots' },
    { value: 'labels', label: 'Draw event labels' }
  ];
</script>

<Accordion.Item value="reference-roast-event-display">
  <Accordion.Trigger>Reference roast event display</Accordion.Trigger>
  <Accordion.Content>
    <div class="flex flex-col gap-y-4 px-2">
      <div class="w-full">
        <Label for="referenceRoastEventDisplay"
          >Choose how to view the reference roast's events</Label
        >

        <RadioGroup.Root
          name="referenceRoastEventDisplay"
          bind:value={referenceRoastEventDisplay.current}
          class="mt-2 space-y-2"
        >
          {#each displayOptions as option (option.value)}
            <div class="flex items-center space-x-2">
              <RadioGroup.Item value={option.value} id={option.value} />
              <Label for={option.value} class="text-sm font-normal">{option.label}</Label>
            </div>
          {/each}
        </RadioGroup.Root>
      </div>
    </div>
    <div class="pt-2 text-xs">
      <p class="mb-2">
        <strong>Draw event dots:</strong> Using dots will draw a small dot on the roast chart. Hover over
        the dot to see the event details, time and temperature. Select this if you like a clean uncluttered
        chart.
      </p>
      <p>
        <strong>Draw event labels:</strong> Choose event labels if you like to see all of the information
        from your previous events all the time. Hover over each label to highlight it.
      </p>
    </div>
  </Accordion.Content>
</Accordion.Item>
